/**
 * Single source of truth for the staff-only end-user docs.
 *
 * Adding a doc:
 *   1. Drop the .md in /docs/guides/<slug>.md
 *   2. Add an entry below
 *
 * Both the sidebar menu (`menu-structure.ts`) and the index page
 * (`docs-index-page.tsx`) read from this list.
 */
export interface DocEntry {
	slug: string;
	title: string;
	/** Shown on the index page card; omit for entries that only need a menu item. */
	blurb: string;
	/** Approximate reading time, shown on the index card. */
	readTime: string;
}

export const DOCS: DocEntry[] = [
	{
		slug: "assignment-setup",
		title: "Assignment setup",
		blurb: "How keywords, preferred companies, requirements, and filters shape your queue. Read this first when configuring a new assignment.",
		readTime: "~5 min",
	},
	{
		slug: "grade-connect-queue-build",
		title: "Grade Queue Pipeline",
		blurb: "How candidates are scored and ordered: signal bands (REPLIED, WORKS, CV, ...), hybrid pre-LLM ordering, LLM evaluation flow, and per-mode priority rules.",
		readTime: "~12 min",
	},
	{
		slug: "grading-and-replies",
		title: "Grading & replies",
		blurb: "Day-to-day workflow: hotkeys, what each vote does for ML training, LLM_NO override list, and how replies feed back into queue order.",
		readTime: "~6 min",
	},
];
